import {ActionTree} from 'vuex'
import axios, {AxiosResponse, AxiosError} from "axios";
import {Md5} from 'ts-md5/dist/md5'

export const actions: ActionTree<any, any> = {

    getPanelStats: ({state, getters, commit, dispatch}, force) => {

        const postData = getters.activeFilters(state.panelFilters);

        const cacheHash = Md5.hashStr('panelStats' + JSON.stringify(postData));

        commit('setLoading', true);

        return new Promise((resolve, reject) => {

            let cached = null;

            if (!force) {
                cached = getters.getCacheItem(cacheHash);
            }

            if (cached) {
                commit('setPanelStats', cached.item);
                commit('setLoading', false);
                resolve(cached);

            } else {

                let url = '/financial-reports/panel';

                if (force) url += '?force=true';

                axios.post(url, postData)

                    .then(({data}) => {

                        commit('setCacheItem', {hash: cacheHash, data: data.stats});
                        commit('setPanelStats', data.stats);
                        commit('setLoading', false);
                        resolve(data.stats);
                    })
                    .catch(error => {

                        commit('setLoading', false);
                        reject(error);
                    });
            }
        });
    },

    getRecruitmentStats: ({state, getters, commit, dispatch}, force) => {

        const postData = getters.activeFilters(state.recruitmentFilters);

        const cacheHash = Md5.hashStr('recruitmentStats' + JSON.stringify(postData));

        commit('setLoading', true);

        return new Promise((resolve, reject) => {

            let cached = null;

            if (!force) {
                cached = getters.getCacheItem(cacheHash);
            }

            if (cached) {
                commit('setRecruitmentStats', cached.item);
                commit('setLoading', false);
                resolve(cached);

            } else {

                let url = '/financial-reports/recruitment-sources';
                if (force) url += '?force=true';

                axios.post(url, postData)

                    .then(({data}) => {

                        commit('setCacheItem', {hash: cacheHash, data: data.stats});
                        commit('setRecruitmentStats', data.stats);
                        commit('setLoading', false);
                        resolve(data.stats);
                    })
                    .catch(error => {

                        commit('setLoading', false);
                        reject(error);
                    });
            }
        });
    },

    getSubPanelStats: ({state, getters, commit, dispatch}, force) => {

        const postData = getters.activeFilters(state.subPanelFilters);

        const cacheHash = Md5.hashStr('subPanelStats' + JSON.stringify(postData));

        commit('setLoading', true);

        return new Promise((resolve, reject) => {

            let cached = null;

            if (!force) {
                cached = getters.getCacheItem(cacheHash);
            }

            if (cached) {
                commit('setSubPanelStats', cached.item);
                commit('setLoading', false);
                resolve(cached);

            } else {

                let url = '/financial-reports/sub-panels';
                if (force) url += '?force=true';

                axios.post(url, postData)

                    .then(({data}) => {

                        commit('setCacheItem', {hash: cacheHash, data: data.stats});
                        commit('setSubPanelStats', data.stats);
                        commit('setLoading', false);
                        resolve(data.stats);
                    })
                    .catch(error => {

                        commit('setLoading', false);
                        reject(error);
                    });
            }
        });
    }
};
